import { render, staticRenderFns } from "./TabPrecificacao.vue?vue&type=template&id=484b2cfb&"
import script from "./TabPrecificacao.vue?vue&type=script&lang=js&"
export * from "./TabPrecificacao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports